import React, { useMemo, useRef, useState } from 'react';
import { Button, Text } from 'src/@vymo/ui/atoms';
import Modal, { Body, Footer, Header } from 'src/@vymo/ui/blocks/modal';
import Form from 'src/@vymo/ui/molecules/form';
import { FormVersion } from 'src/@vymo/ui/molecules/form/types';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { getInputValuesMap } from '../queries';
import { getSelectedTileVo } from '../selector';
import { setSelectedTileData } from '../slice';
import { saveCaptureDetails } from '../thunk';
import { CaptureDetailsActionProps } from '../types';
import styles from '../index.module.scss';

function CaptureDetailsAction({
  widgetCode,
  action,
  error,
}: CaptureDetailsActionProps): JSX.Element {
  const [open, setOpen] = useState(true);
  const formRef = useRef(null);
  const dispatch = useAppDispatch();
  const voDetails = useAppSelector((state) =>
    getSelectedTileVo(state, widgetCode),
  );

  const onCloseHandler = () => {
    setOpen(false);
    dispatch(setSelectedTileData({ widgetCode, data: {} }));
  };

  const onSubmitHandler = async () => {
    // @ts-ignore
    const result = await formRef.current?.getFieldsForSubmission?.();
    if (result?.valid === 'valid') {
      dispatch(
        saveCaptureDetails({
          widgetCode,
          payload: { inputs: result.data },
        }),
      );
    }
  };

  const handleFormChange = () => {};

  const valuesMap = useMemo(
    () => getInputValuesMap(action?.input_fields || []),
    [action.input_fields],
  );

  return (
    <Modal
      open={open}
      showCloseButton
      closeOnEscape
      onClose={onCloseHandler}
      classNames={styles.spg__modal}
    >
      <Header>
        <h2>{action.title}</h2>
      </Header>
      <Body>
        <Form
          key="spg_show_form"
          ref={formRef}
          id="spgShowForm"
          name="spgShowForm"
          onChange={handleFormChange}
          className={styles.form}
          span="1fr"
          config={{
            version: FormVersion.web,
            data: action.input_fields || [],
            grouping: 'card',
            fieldItemConfig: {
              showDisabledIcon: true,
            },
            groupConfig: {
              collapsibleClasses: styles.form__collapsible,
            },
            viewMode: false,
          }}
          formulaContext={{ data: { vo: voDetails } }}
          value={valuesMap}
        />
        {error && <Text variant="error">{error}</Text>}
      </Body>
      <Footer>
        <Button type="primary" onClick={onSubmitHandler}>
          Submit
        </Button>
      </Footer>
    </Modal>
  );
}

export default CaptureDetailsAction;
